import { computed, Injectable, signal } from '@angular/core';

export enum DedicatedClients {
  Shared = 'shared',
  Kinetic = 'kinetic',
}

export interface DedicatedClientConfig {
  tabTitle?: string;
  showCommonAuthDecor?: boolean;
  hideForgotPassword?: boolean;
  authLogoSrc?: string;
  authLogoConfig?: {
    width: number;
    height: number;
  };
  documentBodyClass?: string;
  resetPasswordSenderEmail: string;
  resetPasswordSenderDomain: string;
  documentPrimaryTextColorClass?: string;
  documentPrimaryBGColorClass?: string;
}

const DedicatedClientConfigsMap: Record<DedicatedClients, DedicatedClientConfig> = {
  [DedicatedClients.Shared]: {
    showCommonAuthDecor: true,
    resetPasswordSenderEmail: 'system@pinnakl.com',
    resetPasswordSenderDomain: 'system@pinnakl.com',
    authLogoSrc: '/assets/images/big-logo.png',
  },
  [DedicatedClients.Kinetic]: {
    tabTitle: 'Kinetic Investor Portal',
    authLogoSrc: '/assets/images/kinetic_logo.png',
    authLogoConfig: {
      width: 146,
      height: 42,
    },
    documentBodyClass: 'kinetic-app',
    resetPasswordSenderEmail: 'ir@kineticpartners.com',
    resetPasswordSenderDomain: 'kineticpartners.com',
    documentPrimaryTextColorClass: 'kinetic-primary-text-color',
    documentPrimaryBGColorClass: 'kinetic-primary-bg-color',
  },
};

@Injectable({
  providedIn: 'root',
})
export class DedicatedPortalClientService {
  private readonly currentClient = signal<DedicatedClients>(DedicatedClients.Shared);
  readonly config = computed(() => DedicatedClientConfigsMap[this.currentClient()]);
  readonly dedicatedClient = computed(() => this.currentClient());

  constructor() {
    switch (true) {
      case window.location.origin.includes('kinetic'): {
        this.currentClient.set(DedicatedClients.Kinetic);
        break;
      }
      default:
        break;
    }
  }
}
